import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Ee = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { fill: "#000000", d: "M21,4.667H0v4.667h21V4.667z" }),
    React.createElement("path", { fill: "#0072CE", d: "M21,0H0v4.667h21V0z" }),
    React.createElement("path", { fill: "#F5F5F5", d: "M21,9.333H0V14h21V9.333z" })), 'Ee', { width: 21, height: 14, viewBox: '0 0 21 14' });
export default Ee;
